import { API } from "../urls";

const getHeaders = () => ({
    "Content-Type": "application/json",
});

const fetchOpts = { credentials: "include" };

/** Panelde şu an gösterilecek duyurular. */
export const getActiveAnnouncements = async () => {
    const res = await fetch(API.announcements_active, { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Duyurular alınamadı");
    return res.json();
};

// ─── SUPER_ADMIN ─────────────────────────────────────────────

/** Pasif ve süresi dolmuş kayıtlar dahil tüm duyurular. */
export const getAllAnnouncements = async () => {
    const res = await fetch(API.announcements, { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Duyurular alınamadı");
    return res.json();
};

export const createAnnouncement = async (payload) => {
    const res = await fetch(API.announcements, {
        ...fetchOpts,
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error((await res.json()).message || "Duyuru oluşturulamadı");
    return res.json();
};

export const updateAnnouncement = async (id, payload) => {
    const res = await fetch(API.announcement_detail(id), {
        ...fetchOpts,
        method: "PUT",
        headers: getHeaders(),
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error((await res.json()).message || "Duyuru güncellenemedi");
    return res.json();
};

export const deleteAnnouncement = async (id) => {
    const res = await fetch(API.announcement_detail(id), {
        ...fetchOpts,
        method: "DELETE",
        headers: getHeaders(),
    });
    if (!res.ok) throw new Error((await res.json()).message || "Duyuru silinemedi");
    return res.json();
};
